import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TbInfoTriangle } from "react-icons/tb";

import CommonAlert from "@/components/CommonAlert";
import useClinicArrivalTaskDetailAssignation from "@/providers/hooks/useClinicArrivalTaskDetailAssignation";
import {
    useClinicArrivalTasksDetailUnassignDialog,
    useClinicArrivalTasksGridActions,
} from "@/stores/use-clinic-arrival-tasks-grid";

function ClinicArrivalTasksDetailUnassignDialog() {
    const { t } = useTranslation();
    const showDialog = useClinicArrivalTasksDetailUnassignDialog();
    const { handleUnassignPassengersFromTask, unassignPending } = useClinicArrivalTaskDetailAssignation();
    const { updateShowTasksDetailUnassignDialog } = useClinicArrivalTasksGridActions();

    const handleConfirm = async () => {
        if (unassignPending || !showDialog) return;

        await handleUnassignPassengersFromTask({
            taskId: showDialog.taskId,
            listItemIds: showDialog.listItemIds,
        });
        handleClose();
    };

    const handleClose = () => {
        updateShowTasksDetailUnassignDialog(null);
    };

    return (
        <CommonAlert
            open={!!showDialog}
            loading={unassignPending}
            description="confirmations.bulkTaskUnassign"
            color="error"
            onClose={handleClose}
            handleConfirm={handleConfirm}
            html
            descriptionOpts={{
                count: showDialog?.listItemIds.length || 1,
            }}
        >
            {showDialog && showDialog.totalPassengers === showDialog.listItemIds.length && (
                <Alert icon={<TbInfoTriangle />} className="mt-2" severity="error">
                    {t("infos.taskWillRemoved")}
                </Alert>
            )}
        </CommonAlert>
    );
}

export default ClinicArrivalTasksDetailUnassignDialog;
